import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { usePerson } from 'contexts/person'
import { getFullName } from 'utilities/person'
import Modal from 'modals/dialog'
import { For } from './s'

const SubordinatesHero = () => {
    const { formatMessage } = useIntl()

    const { person } = usePerson()

    return (
        <Modal.Header
            heading={formatMessage({
                id: 'person_label_subordinates',
                defaultMessage: 'Subordinates'
            })}
            caption={(
                <For>
                    <FormattedMessage
                        id="for_name"
                        defaultMessage="for {name}"
                        values={{
                            name: <span>{getFullName(person)}</span>
                        }} />
                </For>
            )} />
    )
}

export default SubordinatesHero
